export const SoilRanges: Record<string, [number, number]> = {
  N: [0.03, 0.37],
  K: [31, 488],
  P: [2.6, 95],
  pH: [4.8, 7.1], // I assumed 7.1 instead of 71, since soil pH > 14 is unusual
  Soil_Texture: [1, 4],
  CEC: [22, 47],
  C: [0.3, 5.4],
  BulkDensity: [1.1, 1.79],
};
